import React, { useEffect } from 'react';

function useClickOutside(references: React.RefObject<any>[], clickOutsideCallback: Function) {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        references.every(
          (reference: React.RefObject<any>) =>
            reference.current && !reference.current.contains(event.target),
        )
      )
        clickOutsideCallback(event);
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [references]);
}

export { useClickOutside };
